import { reducerWithInitialState } from 'typescript-fsa-reducers'

import EventHubState from '../states/EventHubState'
import { EventHub } from '../actions'

export const initialState: EventHubState = {
  subscriptions: {}
}

export default reducerWithInitialState(initialState)
  .case(EventHub.eventUpdate, (state, update) => {
    const { channel, lastID } = update
    return {
      ...state,
      subscriptions: {
        ...state.subscriptions,
        [channel]: {
          ...state.subscriptions[channel],
          lastID
        }
      }
    }
  })
  .case(EventHub.subscribe, (state, { channel, tag }) => ({
    ...state,
    subscriptions: {
      ...state.subscriptions,
      [channel]: {
        lastID: '',
        tag
      }
    }
  }))
  .case(EventHub.unsubscribe, (state, channel) => {
    const { subscriptions } = state
    const newSubscriptions = { ...subscriptions }
    delete newSubscriptions[channel]
    return {
      ...state,
      subscriptions: newSubscriptions
    }
  })
  .build()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/eventHub.ts